import { Injectable } from '@angular/core';
import firebase from 'firebase/app';
import { AngularFirestore } from "angularfire2/firestore";

@Injectable()
export class AdminProvider {

  constructor(
    private afs: AngularFirestore
  ) {}

  uploadJson(program_id: string, program_admin_doc: string, json: Array<any>, user: any)  {
    const batch = this.afs.firestore.batch();
    json.forEach((item: any) => {
      const id = this.afs.createId();
      const ts = this.timestamp;
      item.id = id;
      if (item.dob) item.dob = new Date(item.dob);
      if (item.consent_written) {
        item.consent_written_createdAt = ts;
        item.consent_written_createdBy = 'System'
        item.consent_written_createdById = 'System'
        item.consent_written = new Date(item.consent_written);
      }
      if (item.Enrolment_Call_1) {
        item.Enrolment_Call_1_createdAt = ts;
        item.Enrolment_Call_1_createdBy = 'System'
        item.Enrolment_Call_1_createdById = 'System'
        item.Enrolment_Call_1 = new Date(item.Enrolment_Call_1);
      }
      if (item.enrolment_received) {
        item.enrolment_received_createdAt = ts;
        item.enrolment_received_createdBy = 'System'
        item.enrolment_received_createdById = 'System'
        item.enrolment_received = new Date(item.enrolment_received);
      }
      if (item.enrolment_complete)  { 
        item.enrolment_complete_createdAt = ts;
        item.enrolment_complete_createdBy = 'System'
        item.enrolment_complete_createdById = 'System'
        item.enrolment_complete = new Date(item.enrolment_complete);
      }
      if (item.status)  {
        item.status_createdAt = ts;
        item.status_date = ts;
        item.status_createdBy = 'System'
        item.status_createdById = 'System'
      }
      if (item.diagnosis_date) item.diagnosis_date = new Date(item.diagnosis_date);
      const docRef = this.afs.collection(`program/${program_id}/${program_admin_doc}`).doc(id).ref;
      batch.set(docRef, { createdAt: ts, updatedAt: ts, enteredBy: user, ...item});
    });
    return batch.commit();
  }

  get timestamp() {
    return firebase.firestore.FieldValue.serverTimestamp();
  }

}



// WEBPACK FOOTER //
// ./src/providers/admin/admin.ts